import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import FLogger from "@ccint/flogger"
import ajax from "@/utils/request"
import { isMac } from "./utils"
import shared from "@/config/shared"
import i18n from "@/i18n"
import moment from "moment"
import config from "@/config"
import VueClipboard from "vue-clipboard2"
import vuescroll from "vuescroll"
import showMessage from "@/utils/message"
import PubUI from "@ccint/pub-ant-ui"
import "@ccint/pub-ant-ui/lib/pub-ui.css"

Vue.use(vuescroll, {
    ops: {
        bar: {
            background: "#c1c1c1",
            size: "6px",
            keepShow: isMac()
        }
    }
})

import Viewer from "v-viewer"
import "viewerjs/dist/viewer.css"
Vue.use(Viewer)
Viewer.setDefaults({
    inline: false, //启用inline模式
    button: true, //显示右上角关闭按钮
    navbar: true, //显示缩略图导航
    title: false, //显示当前图片的标题
    tooltip: true, //显示缩略百分比
    movable: true, //图片是否可移动
    zoomable: true, //图片是否可缩放
    rotatable: true, //图片是否可旋转
    scalable: true, //图片是否可反转
    transition: true, //使用css3过度
    fullscreen: false, //播放时是否全屏
    keyboard: true,
    toolbar: {
        //按钮配置
        prev: 1,
        next: 1,
        rotateLeft: 1,
        rotateRight: 1
    }
})

import AntdInstall from "./antd.install"
// import "ant-design-vue/dist/antd.css"
AntdInstall(Vue)
import "ant-design-vue/dist/antd.less"

// gloal 样式 覆盖antd
import "./styles/global.scss"

Vue.use(VueClipboard)
Vue.use(PubUI)

// 加载相关插件
Vue.prototype.$ajax = ajax
Vue.prototype.$moment = moment
Vue.prototype.$message = showMessage

// 初始化日志
const url = process.env.VUE_APP_ENV === "online" ? shared.flogOnlineURL : shared.flogDevURL
const env = process.env.VUE_APP_ENV || "dev"

window.fLog = new FLogger({
    url: url, // 地址
    appName: shared.appName, // 项目名称(使用脚手架项目需更改)
    env: env, // 环境
    performKeys: [
        "rs",
        "re",
        "fs",
        "dls",
        "dle",
        "cs",
        "rcs",
        "ce",
        "reqs",
        "ress",
        "ues",
        "uee",
        "dl",
        "rese",
        "di",
        "dcles",
        "dclee",
        "dc",
        "les",
        "lee"
    ],
    errnoNameArr: ["errno", "err_no", "code"],
    autoLogAjax: false
})

window.addEventListener("load", () => {
    window.$$version.init({
        baseUrl: config.api.SDL_URL,
        css: "color:#8C8C8C"
    })
})

Vue.config.errorHandler = function(err) {
    window.fLog.errorCallback(err)
    throw new Error(`${err}`)
}

Vue.config.productionTip = false

Vue.prototype.formLayout = (width = "100px") => ({
    labelCol: { style: { width, float: "left" } },
    wrapperCol: { style: { width: `calc(100% - ${width})`, float: "left" } }
})

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount("#app")
